/**
 * What becomes of a household's miles when they delete their account.
 *
 * The privacy notice promises this choice in as many words, so it is asked
 * rather than decided for them. Mirrors the API's own values.
 */
export enum MileageDisposition {
  /** The miles stay in the campaign figure, with no name attached to them. */
  KeepInTotal = "keep_in_total",
  /** The campaign figure comes down by what this household rode. */
  RemoveFromTotal = "remove_from_total",
}
